<template>
  <div class="banner_nav">
    <div class="banner_nav_box">
      <div class="banner_nav_center flex_row">
        <div class="left animated fadeInLeft">
          <p style="font-size: 26px">快速定位服务</p>
          <p style="font-size: 16px">一键到位解决需求服务问题</p>
          <p style="font-size: 26px">Easy Steps</p>
          <p style="font-size: 16px">Solve the service trouble</p>
        </div>
        <div class="right flex_row">
          <div
            class="icon animated fadeInRight"
            v-for="(item, index) in bannerTxt"
            :key="index"
            @click="openService(index)"
          >
            <img :src="item.img" />
            <p class="icon_txt">{{ item.name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BannerTxt",
  data() {
    return {
      bannerTxt: [
        {
          name: "云服务",
          img: require("../../assets/banner_nav_icon1.png"),
        },
        {
          name: "软件定制",
          img: require("../../assets/banner_nav_icon2.png"),
        },
        {
          name: "集成系统",
          img: require("../../assets/banner_nav_icon3.png"),
        },
        {
          name: "解决方案",
          img: require("../../assets/banner_nav_icon4.png"),
        },
      ],
    };
  },
  methods: {
    //技术服务
    openService(index) {
      if (index == 3) {
        index = 6;
      }
      this.$router.push({
        path: "/service",
        query: {
          index: index,
          tabName:index == 6 ? JSON.stringify(this.bannerTxt[(this.bannerTxt.length-1)].name) : JSON.stringify(this.bannerTxt[index].name)
        },
      });
    },
  },
};
</script>
<style scoped>
.banner_nav_box {
  /*max-width: 1920px;*/
  margin: 0 auto;
  height: 194px;
  padding-top: 40px;
  box-sizing: border-box;
  background: #2968bd;
}

.banner_nav_center {
  width: 1220px;
  margin: 0 auto;
  justify-content: space-between;
  align-items: flex-end;
}

.banner_nav_center .left {
  color: white;
}

.banner_nav_center .right {
  margin-left: 50px;
}

.banner_nav_center .right .icon {
  text-align: center;
  margin-left: 70px;
}

.banner_nav_center .right .icon img {
  width: 68px;
  height: 68px;
}

.banner_nav_center .right .icon_txt {
  color: white;
  font-size: 16px;
}
.right flex_row {
  margin-left: 203px;
}
.icon img {
  cursor: pointer;
}
.icon animated fadeInRight {
  margin-left: 99px;
}
.icon p {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/components/BannerTxt.vue